<template>
  <div class="container">

    <img src="../assets/img/top-img01.png" class="w100" alt="">
    <img src="../assets/img/02.png" class="w100 img01" alt="">

    <div class="text"> 更好的了解自己，找到对应的TA</div>
    <img src="../assets/img/04.png" class="img04" @click="gobdsm(1)" alt="">
    <img src="../assets/img/05.png" class="img05" @click="gombti(2)" alt="">
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  methods: {
    gobdsm(type) {
      this.$router.push({
        name: "qqqx",
        params: {
          type: type,
        },
        query: {
          uid: this.$route.query.uid || 0,
          token: this.$route.query.token || 0,
          env: this.$route.query.env || 0,
        }
      });
    },
    gombti(type) {
      this.$router.push({
        name: "qqqxMBTI",
        params: {
          type: type
        },
        query: {
          uid: this.$route.query.uid || 0,
          token: this.$route.query.token || 0,
          env: this.$route.query.env || 0,
        }
      });
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Group 2070 */
.img01 {
  width: 2rem;
  margin-left: 15px;
}

.text {
  color: rgba(130, 130, 130, 1);
  font-size: 14px;
  margin-left: 15px;
  margin-top: 10px;

}

.img04 {
  width: 3.45rem;
  margin: 15px auto;
}

.img05 {
  width: 3.45rem;
  margin: 15px auto;

}
</style>
